import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  configList: [],
  configListIsLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_ALL_CONFIG_LIST[REQUEST]:
      return { ...state, configListIsLoaded: false };
    case ActionTypes.GET_ALL_CONFIG_LIST[SUCCESS]:
      return { ...state, configList: action.data, configListIsLoaded: true };
    case ActionTypes.GET_ALL_CONFIG_LIST[FAILURE]:
      return { ...state, error: action.error, configListIsLoaded: false };
    default:
      return state;
  }
};

export default reducer;
